<ng-container *ngIf="content$ | async as page">
  <!-- Intro -->
  <section class="section intro">
    <div class="container-xl">
      <div class="section-title">
        <h1 class="subtitle">{{ page?.title }}</h1>
      </div>
      <div class="section-content">
        <p class="text">{{ page?.description }}</p>
      </div>
    </div>
  </section>

  <!-- livre blanc -->
  <div class="livres-blancs">
    <ng-container *ngFor="let lvDetails of livresblanc$ | async; let isOdd = odd; trackBy: trackByFn">
      <section
        class="section livre-blanc"
        [class.section-dark]="!isOdd"
        [class.section-light]="isOdd"
        [class.livre-blanc-left]="!isOdd"
        [class.livre-blanc-right]="isOdd"
      >
        <div class="section-content">
          <div class="container-xl" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="30px">
            <div class="section-left" fxFlex="50" fxHide.lt-sm>
              <img [src]="lvDetails.image?.url" [alt]="lvDetails.image?.alternativetext" class="w-100" />
            </div>
            <div class="section-right" fxFlex="grow">
              <div class="livre-blanc-content">
                <h2 class="subtitle">{{ lvDetails.titre }}</h2>
                <p class="lead">{{ lvDetails.sous_titre }}</p>
                <div class="image" fxHide fxShow.lt-sm>
                  <img [src]="lvDetails.image?.url" [alt]="lvDetails.image?.alternativetext" class="w-100" />
                </div>
                <a class="btn btn-rounded btn-action" [routerLink]="['/livre-blanc/' + lvDetails.slug]">
                  <span>{{ page?.ctaText }}</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </ng-container>
  </div>
</ng-container>

<!-- Garanties -->
<b2b-ui-section-garantee></b2b-ui-section-garantee>
